import { render, staticRenderFns } from "./StuTeacherForm.vue?vue&type=template&id=cf84a684&scoped=true"
import script from "./StuTeacherForm.vue?vue&type=script&lang=js"
export * from "./StuTeacherForm.vue?vue&type=script&lang=js"
import style0 from "./StuTeacherForm.vue?vue&type=style&index=0&id=cf84a684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf84a684",
  null
  
)

export default component.exports